// extracted by mini-css-extract-plugin
module.exports = {"copyText":"src-hellospa-components-global-header-copy-text__copyText--1cYzJ","textCopiedMessage":"src-hellospa-components-global-header-copy-text__textCopiedMessage--3Xo6z"};